export default __webpack_public_path__ + "static/breadcrumbs-current-item-do-dark-e6b4fe2b3ed617d40021b90914449541.png";